export default __webpack_public_path__ + "static/media/BrainBreak cards24.4e4822f9.png";